import { Translation } from '@ps/web-shared-components';
import React from 'react';

import Balance, { Type as BalanceType } from '@swf/components/Balance/Balance';

import { TXTCLI_Current_Balance } from './ChestBalance.messages.json';
import styles from './ChestBalance.scss';

export interface Props {
  availableCount?: number;
}

const ChestBalance: React.FC<Props> = ({ availableCount }) => (
  <div className={styles.chestBalance}>
    <Translation {...TXTCLI_Current_Balance} />
    <Balance balance={availableCount ? availableCount : 0} type={BalanceType.Chest} />
  </div>
);

export default ChestBalance;
